import { IRoutingWaypointStationRow } from "../../models";

/** Canonical id + secondaryId equality for station rows (ride, course, station route). */
export const areStationRowsEqual = ({
  a,
  b,
}: {
  a: IRoutingWaypointStationRow;
  b: IRoutingWaypointStationRow;
}): boolean => a.id === b.id && (a.secondaryId ?? 0) === (b.secondaryId ?? 0);
